import { createContext, useContext, type ReactNode } from 'react';
import { RootStore, rootStore } from '../../shared/stores/root-store';

const StoreContext = createContext<RootStore>(rootStore);

export function StoreProvider({ children }: { children: ReactNode }) {
  return (
    <StoreContext.Provider value={rootStore}>{children}</StoreContext.Provider>
  );
}

export function useRootStore(): RootStore {
  return useContext(StoreContext);
}
